import { Constants as AppConstants } from 'shared/resources/Constants';
import { i18nInit } from 'shared/react-utils/i18nHooks';
import Main from 'main/BitbiteMain';
import { BrowserRouter } from 'react-router-dom';

function App() {
  i18nInit(AppConstants.LANGUAGES[AppConstants.LANGUAGE_INDEX].lang);
  return (
    <BrowserRouter>
      <Main />
    </BrowserRouter>
  )
}

export default App;
